(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.fab-MenuAddOption{align-items:center;color:#38312f;cursor:pointer;display:flex;flex-grow:1;font-size:15px;line-height:22px;min-height:42px;padding-left:16px;padding-right:16px;text-decoration:none;-webkit-user-select:none;user-select:none;color:#0b4fd1;fill:#0b4fd1;gap:8px}.fab-MenuAddOption:hover{text-decoration:none}.fab-MenuAddOption:after{content:"";display:block;font-size:0;min-height:inherit;visibility:hidden}.fab-MenuAddOption--active{background-color:#f5f4f1;color:#38312f;color:#0b4fd1;fill:#0b4fd1}.fab-MenuAddOption--anchorBottom{margin-bottom:4px}.fab-MenuAddOption--anchorTop{margin-top:4px}.fab-MenuOption{align-items:center;color:#38312f;cursor:pointer;display:flex;flex-grow:1;font-size:15px;line-height:22px;min-height:42px;padding-left:16px;padding-right:16px;text-decoration:none;-webkit-user-select:none;user-select:none}.fab-MenuOption:hover{text-decoration:none}.fab-MenuOption:after{content:"";display:block;font-size:0;min-height:inherit;visibility:hidden}.fab-MenuOption.fab-MenuOption--toggleable .fab-Checkbox__note{padding-left:0}.fab-MenuOption--active:not(.fab-MenuOption--disabled){background-color:#f5f4f1;color:#38312f}.fab-MenuOption--active:not(.fab-MenuOption--disabled) .fab-MenuOption__parentIcon{fill:#38312f}.fab-MenuOption--active:not(.fab-MenuOption--disabled) .fab-MenuOption__note{color:#777270}.fab-MenuOption--anchorBottom{margin-bottom:4px}.fab-MenuOption--anchorBottom:last-child{margin-bottom:4px}.fab-MenuOption--anchorTop{margin-top:4px}.fab-MenuOption--disabled{color:#777270;cursor:default}.fab-MenuOption--disabled:hover{cursor:default}.fab-MenuOption--disabled .fab-MenuOption__parentIcon{fill:#c6c2bf}.fab-MenuOption--sizeTeenie,.fab-MenuOption--sizeSmall{font-size:14px;line-height:19px}.fab-MenuOption__content{flex-basis:auto;flex-grow:1;min-width:1px;padding-top:10px;padding-bottom:10px}.fab-MenuOption__contentIcon{display:inline-block;align-self:flex-start;margin-top:2px;margin-right:6px;min-width:16px;fill:#38312f}.fab-MenuOption__note{color:#777270;font-size:13px;line-height:19px}.fab-MenuOption__parentIcon{fill:#38312f;display:flex;align-items:center;margin-left:20px}.fab-MenuOption__row{align-items:flex-start;display:flex}[data-fabric-mode=dye] [class^=fab-MenuOption]{outline:1px solid #ff6a00}.fab-MenuList{display:flex;flex-direction:column;overflow:hidden}.fab-MenuList__group:first-child{border-top:none;padding:0}.fab-MenuList__group:first-child .fab-MenuList__groupDivider{border-top:none}.fab-MenuList__group--anchoredTop{padding-top:12px;border-top:none}.fab-MenuList__group--anchoredTop .fab-MenuOption--anchorTop{border-bottom:none}.fab-MenuList__group--anchoredBottom .fab-MenuList__groupDivider{border-top:1px solid #e4e3e0;margin:0}.fab-MenuList__group--anchoredBottom .fab-MenuAddOption{border-top:1px solid #e4e3e0}.fab-MenuList__group--anchoredBottom .fab-MenuOption--anchorBottom{border-top:none}.fab-MenuList__anchorDivider{border-bottom:1px solid #e4e3e0}.fab-MenuList__anchorDividerBottom{margin-bottom:4px;border-bottom:1px solid #e4e3e0}.fab-MenuList__anchorDividerTop{margin-top:4px;border-bottom:1px solid #e4e3e0}.fab-MenuList__groupDivider{border-top:1px solid #e4e3e0;margin:4px 16px}.fab-MenuList__groupText{font-size:13px;line-height:19px;font-weight:600;color:#48413f;padding:4px 16px}.fab-MenuList__placeholder{color:#777270;font-size:13px;padding:8px 12px}.fab-MenuList__scrollContainer{background-color:#fff;flex-grow:1;overflow-x:hidden;overflow-y:auto;max-height:368px}.fab-MenuList__scrollContainer:first-child{padding-top:4px}.fab-MenuList__scrollContainer:last-child{padding-bottom:4px}.fab-MenuList__nested{box-shadow:3px 3px 10px 2px #38312f1a;border-color:#d4d2d0;border-radius:8px;border-style:solid;border-width:1px;display:flex;margin-top:-5px;max-width:368px;max-height:200px;min-width:176px;overflow:hidden}.fab-MenuSearch{align-items:center;display:flex;gap:8px;padding:12px 16px}.fab-MenuSearch__icon{fill:#777270;line-height:0}.fab-MenuSearch__input{border:none;font-family:Inter,sans-serif;font-size:15px;height:18px;line-height:22px;outline:none;width:100%}.fab-MenuSearch__input::placeholder{color:#777270}.fab-MenuVessel{flex-direction:column;max-height:100%;min-width:192px;position:relative}.fab-MenuVessel--width1{width:48px}.fab-MenuVessel--width2{width:64px}.fab-MenuVessel--width3{width:96px}.fab-MenuVessel--width4{width:128px}.fab-MenuVessel--width5{width:160px}.fab-MenuVessel--width6{width:192px}.fab-MenuVessel--width7{width:224px}.fab-MenuVessel--width9{width:352px}.fab-MenuVessel--width10{width:448px}.fab-MenuVessel--width100{width:100%}.fab-MenuVessel--attached{box-shadow:none;box-sizing:border-box}.fab-MenuVessel--attached .fab-MenuVessel__list{max-width:none}.fab-MenuVessel--attached.fab-MenuVessel--top{margin-bottom:-1px;max-height:calc(100% + 1px);border-radius:8px 8px 0 0}.fab-MenuVessel--attached.fab-MenuVessel--top .fab-MenuVessel__outerFacade{border-radius:8px 8px 0 0;bottom:1px;top:-2px}.fab-MenuVessel--attached.fab-MenuVessel--top .fab-MenuVessel__innerFacade{border-radius:8px 8px 0 0;bottom:-1px}.fab-MenuVessel--attached.fab-MenuVessel--top .fab-MenuVessel__list{border-bottom:1px solid #d4d2d0;margin:1px 1px 0;min-width:0}.fab-MenuVessel--attached.fab-MenuVessel--bottom{margin-top:-1px;max-height:calc(100% + 1px)}.fab-MenuVessel--attached.fab-MenuVessel--bottom .fab-MenuVessel__outerFacade{border-radius:0 0 8px 8px;top:1px;bottom:-2px}.fab-MenuVessel--attached.fab-MenuVessel--bottom .fab-MenuVessel__innerFacade{border-radius:0 0 8px 8px;top:-1px}.fab-MenuVessel--attached.fab-MenuVessel--bottom .fab-MenuVessel__list{border-radius:0 0 8px 8px;border-top:1px solid #d4d2d0;min-width:0;outline:0;margin:0 1px 1px}.fab-MenuVessel--bottom{margin-top:9px;max-height:calc(100% - 9px)}.fab-MenuVessel--bottom .fab-MenuVessel__search{border-bottom:1px solid #e4e3e0}.fab-MenuVessel--top{margin-bottom:9px;max-height:calc(100% - 9px)}.fab-MenuVessel--top .fab-MenuVessel__list{flex-direction:column-reverse}.fab-MenuVessel--top .fab-MenuVessel__search{border-top:1px solid #d4d2d0}.fab-MenuVessel--top .fab-MenuVessel__search+.fab-MenuList .fab-MenuList__scrollContainer{padding-bottom:0;padding-top:4px}.fab-MenuVessel__innerFacade{box-shadow:3px 3px 10px 2px #38312f1a;border:1px solid #d4d2d0;border-radius:8px;bottom:2px;left:2px;pointer-events:none;position:absolute;right:2px;top:2px}.fab-MenuVessel__list{background-color:#fff;border-radius:8px;box-sizing:border-box;display:flex;flex-direction:column;max-height:100%;max-width:368px;overflow:hidden}.fab-MenuVessel__outerFacade{bottom:-3px;left:-2px;pointer-events:none;position:absolute;right:-2px;top:-3px}.fab-MenuVessel--width1{min-width:48px}.fab-MenuVessel--width2{min-width:64px}.fab-MenuVessel--width3{min-width:96px}.fab-MenuVessel--width4{min-width:128px}.fab-MenuVessel--width5{min-width:160px}.fab-MenuVessel--width6{min-width:192px}.fab-MenuVessel--width7{min-width:224px}.fab-MenuVessel--width8{width:288px}.fab-MenuVessel--width9{min-width:352px}.fab-MenuVessel--width10,.fab-MenuVessel--width10 .fab-MenuVessel__list{min-width:448px}.fab-MenuVessel__search{padding:4px 0}.fab-MenuVessel__search+.fab-MenuList .fab-MenuList__scrollContainer{padding-top:0}[data-fabric-mode=dye] .fab-MenuVessel{outline:4px solid #ff6a00}')),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
var We = Object.defineProperty;
var Ke = (t, n, e) => n in t ? We(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var g = (t, n, e) => Ke(t, typeof n != "symbol" ? n + "" : n, e);
import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { d as $e } from "./index-DspsydPg.mjs";
import { l } from "./lodash-5ofSKtz3.mjs";
import A, { isValidElement as Ue, cloneElement as ze, Component as G, createRef as j, PureComponent as Ie, Fragment as ue, createContext as Ge, useState as qe, useEffect as ve, useRef as ne, useContext as Je } from "react";
import { s as Qe } from "./index-DDl_rLOB.mjs";
import { H as xe } from "./helium-B4JtMIBI.mjs";
import { c as F } from "./index-DkZ16bcJ.mjs";
import { f as _ } from "./index-LyFokDcn.mjs";
import { I as P } from "./icon-v2-DGtVEk7e.mjs";
import { d as Ze } from "./index-DH8DM7A9.mjs";
import { F as de } from "./fabric-icon-CNOLIwc_.mjs";
import { i as Xe } from "./index-lgh2EImO.mjs";
import { L as Ye } from "./link-unstyled-CvXR-8s6.mjs";
import { C as et } from "./checkbox-DiWnVoeQ.mjs";
import { F as D } from "./flex-Cc3osQLf.mjs";
import { B as tt } from "./body-text-BiQwh5-U.mjs";
import { L as nt } from "./layout-box-DFBM-kSI.mjs";
import { A as st } from "./tss-DN0acMKN.mjs";
import { B as rt } from "./Box-B5hjovXR.mjs";
const Ae = (t) => A.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 5 9", width: "5", height: "9" }, t),
  A.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    A.createElement("path", { fillRule: "nonzero", d: "M0.244077682,1.5363961 C-0.0813592274,1.18492424 -0.0813592274,0.61507576 0.244077682,0.263603897 C0.569514592,-0.0878679656 1.09715207,-0.0878679656 1.42258898,0.263603897 L4.75592232,3.8636039 C5.08135923,4.21507576 5.08135923,4.78492424 4.75592232,5.1363961 L1.42258898,8.7363961 C1.09715207,9.08786797 0.569514592,9.08786797 0.244077682,8.7363961 C-0.0813592274,8.38492424 -0.0813592274,7.81507576 0.244077682,7.4636039 L2.98815536,4.5 L0.244077682,1.5363961 Z" })
  )
);
Ae.displayName = "ChevronRight5x9";
const Ce = (t) => A.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 15 14", width: "15", height: "14" }, t),
  A.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    A.createElement(
      "g",
      { fillRule: "nonzero" },
      A.createElement("path", { d: "M100.935215,71.8802185 L105,75.8615533 L103.868495,77 L99.9404157,73.1525647 C98.8851549,74.1767596 97.4493769,74.8067158 95.8673618,74.8067158 C92.6269074,74.8067158 90,72.1636924 90,68.9033579 C90,65.6430234 92.6269074,63 95.8673618,63 C99.1078163,63 101.734724,65.6430234 101.734724,68.9033579 C101.734724,69.9890273 101.44344,71.0062465 100.935215,71.8802185 Z M95.8673618,73.1200421 C98.1819722,73.1200421 100.058335,71.2321683 100.058335,68.9033579 C100.058335,66.5745475 98.1819722,64.6866737 95.8673618,64.6866737 C93.5527515,64.6866737 91.6763891,66.5745475 91.6763891,68.9033579 C91.6763891,71.2321683 93.5527515,73.1200421 95.8673618,73.1200421 Z", transform: "translate(-90 -63)" })
    )
  )
);
Ce.displayName = "MagGlass15x14";
function Se(t) {
  return typeof t == "string" && t.length ? `--${t}Condition` : "";
}
function R(t, n) {
  const e = z(n);
  return Array.isArray(t) ? t.reduce((s, r, o) => {
    if (!s.length) {
      if (e(r))
        return [o];
      if (r && Array.isArray(r.items)) {
        const i = R(r.items, n);
        if (i.length)
          return [...s, o, ...i];
      }
    }
    return s;
  }, []) : [];
}
function L(t, n = []) {
  const e = [...n], s = e.length ? e.shift() : -1;
  if (s < 0 || !n.length)
    return;
  const r = t[s];
  return e.length && r && Array.isArray(r.items) ? L(r.items, e) : r;
}
function ot({ activeItem: t, items: n = [], searchText: e, selectedItems: s = [] }) {
  const r = H(n || [], e);
  let o = null;
  return Y(r, t) ? o = t : e ? o = q(r) : t === null && s.length && (o = l.last(s)), o;
}
function it(t = "auto", n, e) {
  if (t === "auto" || t === "always") {
    for (const s of e)
      if (s.type !== "group" && s.type !== "add" && typeof s.text != "string")
        return !1;
  }
  if (t === "auto") {
    const s = (e || []).filter((o) => !ie(o)), r = U(s);
    return l.isNumber(n) && r.length >= n;
  }
  return t === "always";
}
function at(t = "", n = "") {
  try {
    return l.startsWith(t.toLowerCase(), n.toLowerCase());
  } catch {
    return !1;
  }
}
function se(t) {
  return l.cloneDeepWith(t, (n) => {
    if (Ue(n))
      return ze(n);
  });
}
const m = Object.seal({
  DOWN: "down",
  LEFT: "left",
  RIGHT: "right",
  UP: "up"
});
function U(t) {
  if (!Array.isArray(t))
    throw new Error('Invalid argument. "items" must be an Array of items');
  return t = se(t), t.reduce((n, e) => {
    const s = Q(e);
    return !s && I(e) && (e.items = U(e.items)), s && I(e) ? n = [...n, ...U(e.items)] : s || n.push(e), n;
  }, []);
}
function k(t = []) {
  return t.reduce((n, e) => (n.push(e), I(e) && (n = [...n, ...k(e.items)]), n), []);
}
function On(t, n) {
  return k(t).filter((e) => n.some((s) => JSON.stringify(s) === JSON.stringify(e.value)));
}
function re(t, n) {
  const e = R(t, n);
  return e.pop(), L(t, e);
}
function oe(t = [], n) {
  const e = re(t, n), s = e ? oe(t, e) : [];
  return [e, ...s];
}
function Oe(t, n = []) {
  return k(t).filter((e) => ae(e, n));
}
function yn(t) {
  return Oe(t).map((n) => n.value);
}
function N(t) {
  if (!Array.isArray(t))
    throw new Error('Invalid argument. "items" must be an Array of items');
  return t = [...t].sort((n, e) => {
    let s = 0;
    return n.anchor === "top" || e.anchor === "bottom" ? s = -1 : (e.anchor === "top" || n.anchor === "bottom") && (s = 1), s;
  }), U(we(t));
}
function ct(t) {
  return k(t).filter(ft);
}
function lt(t) {
  return !!ct(t).length;
}
function q(t) {
  return l.first(N(t));
}
function ye(t) {
  return l.last(N(t));
}
function ut(t, n) {
  return [...t.slice(n), ...t.slice(0, n)];
}
function Ee(t, n, e) {
  let s = N(t);
  const r = R(s, n);
  if (r.length > 1) {
    const i = re(s, n);
    return Ee(N(i.items), n, e);
  }
  if (r && r.length === 1) {
    const i = r[0];
    s = ut(s, i);
  }
  const o = Me(s, e);
  return o.length ? je(o, n, m.DOWN) : n;
}
function En(t) {
  return k(t).map((n) => n.value);
}
function wn(t = []) {
  return t.some((n) => n.exclusive) || !1;
}
function we(t) {
  if (!Array.isArray(t))
    throw new Error('Invalid argument. "items" must be an Array of items');
  return t = se(t), t.reduce((n, e) => (T(e) || (I(e) && (e.items = we(e.items)), n.push(e)), n), []);
}
function Me(t = [], n = "") {
  return H(t, n, mt);
}
function H(t = [], n = "", e = pt) {
  if (!Array.isArray(t))
    throw new Error('Invalid argument. "items" must be an Array of items');
  return t = se(t), t.reduce((s, r) => (e(r, n) && (Q(r) && !ie(r) && (r.items = H(r.items, n, e)), s.push(r)), s), []);
}
function je(t, n, e = m.DOWN) {
  if (!Array.isArray(t))
    throw new Error(
      `Cannot traverse items because the items argument must be an array. Invalid type: ${typeof t} was supplied instead.`
    );
  if (!n)
    return e === m.DOWN ? q(t) : ye(t);
  const s = N(t), r = R(s, n);
  if (e === m.DOWN || e === m.UP)
    return dt(s, r, e);
  if (e === m.LEFT || e === m.RIGHT)
    return ht(s, r, e);
}
function dt(t, n = [], e = m.DOWN) {
  const s = n.slice(0, -1), r = s.length ? L(t, s).items : t, o = l.last(n);
  let i = 0;
  isNaN(o) || (i = e === m.UP ? o - 1 : o + 1), i > r.length - 1 && (i = 0), i < 0 && (i = r.length - 1);
  const c = [...n.slice(0, -1), i];
  return L(t, c);
}
function ht(t, n, e) {
  const s = e === m.RIGHT ? [...n, 0] : [n[0], ...n.slice(1, -1)];
  return L(t, s);
}
function I(t) {
  return !!(t && Array.isArray(t.items) && t.items.length);
}
function Y(t, n) {
  return R(t, n).length > 0;
}
function J(t, n = []) {
  if (!t)
    return !1;
  const e = oe(n, t).some((s) => J(s, n));
  return !!t.isActionOnly || !!t.href || e;
}
function ie(t) {
  return !!t && (t.anchor === "top" || t.anchor === "bottom");
}
function T(t, n = []) {
  if (!t)
    return !1;
  const e = oe(n, t).some((s) => T(s, n));
  return t.isDisabled === !0 || e;
}
function ft(t) {
  return !!t && t.type === "add";
}
function Q(t) {
  return !!t && t.type === "group";
}
function z(t) {
  return (n) => {
    const e = t === n, s = l.isPlainObject(t) && l.isPlainObject(n), r = s && (t.hasOwnProperty("key") || n.hasOwnProperty("key")), o = r && t.key === n.key, i = s && JSON.stringify(t.value) === JSON.stringify(n.value);
    return e || (r ? o : i);
  };
}
function Fe(t, n, e = H) {
  let s = !1;
  return Q(t) && (s = e(t.items, n).length > 0 || ie(t)), s;
}
function De(t = {}, n = "", e = Qe.hasWordStartingWith) {
  return !Q(t) && e(t.text, n);
}
function ae(t, n = []) {
  const e = z(t);
  return n.length ? n.some(e) : !!t.isSelected;
}
function pt(t, n) {
  return De(t, n) || Fe(t, n);
}
function mt(t, n) {
  return De(t, n, at) || Fe(t, n, Me);
}
function ee(t, n) {
  const { activeItem: e, items: s } = n;
  return Ee(s, e, t);
}
function _t(t) {
  if (!t)
    return !1;
  const { selectionStart: n, selectionEnd: e } = t;
  return n === 0 && e === 0;
}
function gt(t) {
  if (!t)
    return !1;
  const {
    value: { length: n },
    selectionStart: e,
    selectionEnd: s
  } = t;
  return e === n && s === n;
}
function Pe(t) {
  t.focus();
}
function bt(t = {}) {
  return t.ctrlKey || t.metaKey;
}
function he(t) {
  return !!t && (t === document.activeElement || t.contains(document.activeElement));
}
function fe(t) {
  return (n) => !!(n && n.closest(`[data-menu-id="${t}"]`));
}
function It(t = "") {
  const n = ["Enter", "Escape"];
  return l.includes(n, t);
}
function vt(t = "") {
  const n = [" ", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "End", "Enter", "Home", "PageDown", "PageUp", "Tab"];
  return l.includes(n, t);
}
function xt(t) {
  return {
    ArrowDown: m.DOWN,
    ArrowLeft: m.LEFT,
    ArrowRight: m.RIGHT,
    ArrowUp: m.UP,
    Down: m.DOWN,
    Left: m.LEFT,
    Right: m.RIGHT,
    Up: m.UP
  }[t];
}
function te(t) {
  return {
    Down: "ArrowDown",
    Left: "ArrowLeft",
    Right: "ArrowRight",
    Up: "ArrowUp",
    Esc: "Escape",
    Spacebar: " "
  }[t] || t;
}
function At(t, n) {
  const { cursorIsAtBeginningOfInput: e, cursorIsAtEndOfInput: s, inputIsFocused: r, isOpen: o } = n, i = ["ArrowDown", "ArrowLeft", "ArrowRight", "ArrowUp", "End", "Home", "PageUp", "PageDown"];
  let c = o && l.includes(i, t);
  return c && r && (t === "ArrowLeft" && !e || t === "ArrowRight" && !s) && (c = !1), c;
}
function Ct(t, n) {
  const { isOpen: e } = n;
  return e && (t === "Home" || t === "PageUp");
}
function St(t, n) {
  const { isOpen: e } = n;
  return e && (t === "End" || t === "PageDown");
}
function Ot(t = "", n, e) {
  const { inputIsFocused: s, isOpen: r } = n;
  return r && !s && Le(t, n, e);
}
function yt(t, n) {
  const { activeItem: e, anchorIsFocused: s, cursorIsAtEndOfInput: r } = n;
  return !s && (t === "ArrowRight" && r && I(e) || It(t));
}
function Et(t, n) {
  const { isOpen: e } = n;
  return t === "Escape" && e;
}
function wt(t, n) {
  const { inputIsFocused: e, isOpen: s } = n;
  return s && e && (t === "Home" || t === "End");
}
function Mt(t, n, { canQuickSelect: e = !0, canSelectMultiple: s = !1 } = {}) {
  const { activeItem: r, isOpen: o, items: i } = n, c = ee(t, n), h = !!c && c !== r, u = J(c, i), d = s && h, f = I(c);
  return (t === "ArrowDown" || t === " " || t === "Enter" || e && (d || f || u)) && !o;
}
function jt(t, n) {
  const { anchorIsFocused: e, cursorIsAtEndOfInput: s, cursorIsAtBeginningOfInput: r, inputIsFocused: o, isOpen: i } = n;
  return i ? o && (t === "ArrowLeft" || t === "ArrowRight" || t === " ") ? t === "ArrowLeft" && r || t === "ArrowRight" && s : vt(t) : e && (t === "ArrowDown" || t === " ");
}
function Ft(t, n) {
  const { activeItem: e, inputIsFocused: s, isOpen: r } = n;
  return !!(r && e && (t === "Enter" || t === " " && !s));
}
function Dt(t = "", n, e) {
  const { isOpen: s } = n;
  return !s && Le(t, n, e);
}
function Le(t = "", n, { canQuickSelect: e = !1 }) {
  const s = t.length === 1 && /\S/.test(t);
  return e && s;
}
function Pt(t, n) {
  const { activeItem: e, items: s } = n;
  let r = e;
  const o = xt(t);
  return o ? r = je(s, e, o) : Ct(t, n) ? r = q(s) : St(t, n) && (r = ye(s)), r;
}
function Lt(t, n) {
  const { key: e, shiftKey: s } = t;
  let { selectionEnd: r, selectionStart: o } = n;
  const i = te(e);
  (i === "Home" || i === "End") && (i === "Home" ? (o = 0, r = s ? r : o) : i === "End" && (r = n.value.length, o = s ? o : r), n.setSelectionRange(o, r));
}
class Ne extends G {
  constructor() {
    super(...arguments);
    g(this, "_handleFocus", (e) => {
      const { isDisabled: s } = this.props;
      s ? e.stopPropagation() : this.setState({ isFocused: !0 });
    });
    g(this, "_handleBlur", (e) => {
      const { isDisabled: s, onBlur: r } = this.props;
      s ? e.stopPropagation() : (this.setState({ isFocused: !1 }), typeof r == "function" && r(e));
    });
    g(this, "_handleClick", (e) => {
      const { isDisabled: s, isOpen: r, onClose: o, onOpen: i } = this.props, { nativeEvent: c } = e, h = c && c.detail === 0 && !c.isPrimary;
      s || h || (e.target.closest("label") && e.preventDefault(), r ? o() : i());
    });
    g(this, "_handleKeydown", (e) => {
      const { isAdding: s } = this.props;
      !s && !bt(e) && (this._updateDom(e), this._updateProps(e));
    });
    g(this, "state", {});
    g(this, "_ref", j());
  }
  focus() {
    Pe(this._ref.current);
  }
  _addKeyEvents() {
    const { isDisabled: e } = this.props;
    e || document.addEventListener("keydown", this._handleKeydown);
  }
  _getState(e) {
    const { target: s } = e, r = this._ref.current, o = s.closest('input[type="text"]'), { activeItem: i, items: c, isOpen: h } = this.props;
    return {
      activeItem: i,
      anchorIsFocused: he(r),
      cursorIsAtBeginningOfInput: _t(o),
      cursorIsAtEndOfInput: gt(o),
      inputIsFocused: he(o),
      items: c,
      isOpen: h
    };
  }
  _removeKeyEvents() {
    document.removeEventListener("keydown", this._handleKeydown);
  }
  _updateDom(e) {
    const { key: s, target: r } = e, o = te(s), i = this._getState(e), c = r.closest('input[type="text"]');
    jt(o, i) && e.preventDefault(), wt(o, i) && Lt(e, c), yt(o, i) && this.focus();
  }
  _updateProps(e) {
    const { activeItem: s, canQuickSelect: r = !1, canSelectMultiple: o, onActiveItemChange: i, onClose: c, onOpen: h, onSelect: u } = this.props, d = te(e.key), f = this._getState(e);
    Et(d, f) ? c() : Mt(d, f, { canQuickSelect: r, canSelectMultiple: o }) && h(), At(d, f) ? i(Pt(d, f)) : Ot(d, f, { canQuickSelect: r }) && i(ee(d, f)), Ft(d, f) ? u(s) : Dt(d, f, { canQuickSelect: r }) && u(ee(d, f), !0);
  }
  componentDidMount() {
    const { isOpen: e } = this.props;
    e && this._addKeyEvents();
  }
  componentDidUpdate() {
    const { isOpen: e } = this.props, { isFocused: s } = this.state;
    e || s ? this._addKeyEvents() : this._removeKeyEvents();
  }
  componentWillUnmount() {
    this._removeKeyEvents();
  }
  render() {
    const { ariaLabel: e, biId: s, isFullWidth: r, isDisabled: o, isOpen: i, menuId: c, menuPlacement: h, renderToggle: u, selectedItems: d } = this.props, { isFocused: f } = this.state, p = !o && (f || i), b = {
      width: r ? "100%" : null
    }, v = {
      "data-menu-id": c
    }, S = {
      onBlur: this._handleBlur,
      onClick: this._handleClick,
      onFocus: this._handleFocus
    }, O = i ? { "aria-controls": c } : {};
    return s && (v["data-bi-id"] = `${s}-menu-toggle`), /* @__PURE__ */ a.jsx(a.Fragment, { children: u(
      { appliedPlacement: h, isFocused: p, selectedItems: d },
      {
        ...v,
        ...S,
        ...O,
        "aria-expanded": i,
        "aria-haspopup": !0,
        "aria-label": e,
        ref: this._ref,
        style: b,
        tabIndex: 0
      }
    ) });
  }
}
g(Ne, "defaultProps", {
  onActiveItemChange: l.noop,
  onClose: l.noop,
  onOpen: l.noop,
  onSelect: l.noop
});
class Te extends G {
  constructor() {
    super(...arguments);
    g(this, "_handleClick", (e) => {
      const { isDescendant: s, onClickOut: r = l.noop } = this.props;
      s(e.target) || r();
    });
  }
  _addClickEvent() {
    document.addEventListener("click", this._handleClick);
  }
  _removeClickEvent() {
    document.removeEventListener("click", this._handleClick);
  }
  componentDidMount() {
    const { isEnabled: e } = this.props;
    e && this._addClickEvent();
  }
  componentDidUpdate() {
    const { isEnabled: e } = this.props;
    e ? this._addClickEvent() : this._removeClickEvent();
  }
  componentWillUnmount() {
    const { isEnabled: e } = this.props;
    e && this._removeClickEvent();
  }
  render() {
    const { children: e } = this.props;
    return e || null;
  }
}
g(Te, "defaultProps", {
  isEnabled: !1
});
const Nt = window.jQuery ? $.__("No results...") : "No results...";
function Tt({ isAttached: t, menuPlacement: n = {}, width: e }) {
  return F("fab-MenuVessel", {
    "fab-MenuVessel--attached": t,
    "fab-MenuVessel--bottom": n.side === "bottom",
    "fab-MenuVessel--top": n.side === "top",
    ..._.ifFeature("encore", { [`fab-MenuVessel--width${e}`]: e })
  });
}
function Rt({ condition: t = "" } = {}) {
  return F("fab-MenuVessel__innerFacade", {
    [`fab-MenuVessel__innerFacade${Se(t)}`]: !!t
  });
}
function kt(t) {
  const { isActive: n, anchor: e } = t;
  return F("fab-MenuAddOption", {
    "fab-MenuAddOption--active": n,
    "fab-MenuAddOption--anchorBottom": e === "bottom",
    "fab-MenuAddOption--anchorTop": e === "top"
  });
}
function pe() {
  return _.ifFeature("encore", window.jQuery ? $.__("Add...") : "Add...", window.jQuery ? $.__("+ Add Item") : "+ Add Item");
}
function Ht(t) {
  const { biId: n = null, children: e, onHover: s, onSelect: r } = t, o = {};
  return n && (o["data-bi-id"] = `${n}-menu-add-option`), /* Key events are being handled by the "Anchor" component and no other role makes sense for this element. */
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  /* @__PURE__ */ a.jsx("div", { ...o, className: kt(t), onClick: r, onMouseEnter: s, children: e || _.ifFeature(
    "encore",
    /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      /* @__PURE__ */ a.jsx(P, { name: "circle-plus-regular", size: 16 }),
      pe()
    ] }),
    pe()
  ) });
}
function Vt(t, n, e = {}) {
  const s = n.value && typeof n.value == "string" ? n.value : n.key, r = e && typeof e.value == "string" ? e.value : e.key;
  return `${t}-menu-option${r ? `-${l.kebabCase(r)}` : ""}${s ? `-${l.kebabCase(s)}` : ""}`;
}
function Bt(t = {}) {
  const { anchor: n, isActive: e, isDisabled: s, isGroupChild: r, isToggleable: o, size: i } = t;
  return F({
    "fab-MenuOption": !0,
    "fab-MenuOption--active": e,
    "fab-MenuOption--anchorBottom": n === "bottom",
    "fab-MenuOption--anchorTop": n === "top",
    "fab-MenuOption--disabled": s,
    "fab-MenuOption--groupChild": r,
    "fab-MenuOption--toggleable": o,
    [`fab-MenuOption--size${l.capitalize(i)}`]: !!i
  });
}
function Re(t) {
  const { parentElement: n } = t;
  if (!(!n || t.hasAttribute("data-menu-id")))
    return n.scrollHeight > n.clientHeight ? n : Re(n);
}
function Wt(t) {
  const { canSelectMultiple: n, exclusive: e, isActionOnly: s, isParent: r } = t;
  return !!n && !r && !s && !e;
}
function Kt(t) {
  const n = Re(t);
  if (!n || !document.body.contains(n))
    return;
  const e = n.getBoundingClientRect(), r = t.getBoundingClientRect().top - e.top;
  let { scrollTop: o } = n;
  r < 0 ? o += r : r + t.clientHeight > n.clientHeight && (o += r + t.clientHeight - n.clientHeight), n.scrollTop = o;
}
const $t = ({ constructs: t, typography: n }, { isDisabled: e, isSelected: s }) => {
  const r = s ? t.text.neutral.xStrong : t.text.neutral.strong, o = s ? "#222" : "#555";
  return {
    checkboxLabel: {
      color: _.ifFeature(
        "encore",
        e ? t.text.neutral.weak : r,
        e ? "#686868" : o
      ),
      cursor: e ? "default" : "pointer",
      fontWeight: s && !e ? n.fontWeightBold : n.fontWeightRegular
    },
    jadeIcon: {
      fill: e ? "#686868" : "#222"
    }
  };
};
class Ut extends Ie {
  constructor() {
    super(...arguments);
    g(this, "_ref", j());
  }
  _scrollActiveItemIntoView() {
    const { isActive: e } = this.props;
    e && window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        Kt(this._ref.current);
      });
    });
  }
  _renderContent() {
    const { isActive: e, isDisabled: s, isParent: r, item: o, renderContent: i = l.noop } = this.props;
    return i(o, { isActive: e, isDisabled: s, isParent: r }) || null;
  }
  _renderWithCheckbox() {
    const { classes: e, isDisabled: s, isSelected: r, id: o, item: i, size: c } = this.props, h = this._renderContent(), u = i.id || l.uniqueId("option-checkbox-");
    return /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__content", children: /* @__PURE__ */ a.jsx(D, { flexDirection: "column", children: /* @__PURE__ */ a.jsxs(D, { alignItems: "center", children: [
      /* @__PURE__ */ a.jsx(D, { alignSelf: "start", marginRight: 1, position: "relative", top: _.ifFeature("encore", "-4px", "-1px"), children: /* @__PURE__ */ a.jsx(
        et,
        {
          checked: r,
          disabled: s,
          id: u,
          onChange: l.noop,
          size: c === "small" || c === "teenie" ? "small" : "medium"
        }
      ) }),
      h || /* 
      This is the label and note for the Checkbox component. We cannot use the "label" or "note" prop on the Checkbox
      component because it will make the text unclickable.
      */
      /* @__PURE__ */ a.jsxs(D, { flexDirection: "column", children: [
        i.icon ? /* @__PURE__ */ a.jsxs(D, { alignItems: "center", alignSelf: "center", gap: 1, children: [
          _.ifFeature(
            "encore",
            typeof i.icon == "string" ? /* @__PURE__ */ a.jsx(
              P,
              {
                color: s ? "neutral-strong" : "neutral-extra-extra-strong",
                name: i.icon,
                size: 16
              }
            ) : i.icon,
            /* @__PURE__ */ a.jsx("div", { className: e.jadeIcon, children: typeof i.icon == "string" ? /* @__PURE__ */ a.jsx(de, { name: i.icon }) : i.icon })
          ),
          /* @__PURE__ */ a.jsx("label", { className: e.checkboxLabel, htmlFor: u, id: `${u}-label`, children: i.text })
        ] }) : /* @__PURE__ */ a.jsx("label", { className: e.checkboxLabel, htmlFor: u, id: `${u}-label`, children: i.text }),
        i.note && !h ? /* @__PURE__ */ a.jsx(nt, { marginTop: 0.25, children: /* @__PURE__ */ a.jsx(
          tt,
          {
            color: "neutral-weak",
            id: `${u}-note`,
            weight: r && !s ? "semibold" : "normal",
            size: "extra-small",
            children: i.note
          }
        ) }) : null
      ] })
    ] }) }) });
  }
  _renderWithoutCheckbox() {
    const { isParent: e, item: s } = this.props, r = this._renderContent();
    return /* @__PURE__ */ a.jsxs(ue, { children: [
      /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__content", children: r || /* @__PURE__ */ a.jsx(ue, { children: /* @__PURE__ */ a.jsxs("div", { className: "fab-MenuOption__row", children: [
        s.icon ? _.ifFeature(
          "encore",
          /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__contentIcon", children: typeof s.icon == "string" ? /* @__PURE__ */ a.jsx(P, { name: s.icon, size: 16 }) : s.icon }, "icon"),
          /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__contentIcon", children: typeof s.icon == "string" ? /* @__PURE__ */ a.jsx(de, { name: s.icon }) : s.icon }, "icon")
        ) : null,
        /* @__PURE__ */ a.jsxs("div", { children: [
          s.text,
          s.note ? /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__note", children: s.note }) : null
        ] })
      ] }) }) }),
      e && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuOption__parentIcon", children: _.ifFeature("encore", /* @__PURE__ */ a.jsx(P, { name: "caret-right-solid", size: 16 }), /* @__PURE__ */ a.jsx(Ae, {})) })
    ] });
  }
  componentDidMount() {
    this._scrollActiveItemIntoView();
  }
  componentDidUpdate(e) {
    const { isActive: s } = e, { isActive: r } = this.props;
    r && r !== s && this._scrollActiveItemIntoView();
  }
  render() {
    const {
      anchor: e,
      biId: s,
      canSelectMultiple: r,
      isActionOnly: o,
      isActive: i,
      isDisabled: c,
      isExpanded: h,
      isGroupChild: u,
      isParent: d,
      isSelected: f,
      item: p,
      onHover: b = l.noop,
      onSelect: v = l.noop,
      parentItem: S = {},
      size: O,
      role: x
    } = this.props, w = Wt({
      canSelectMultiple: r,
      exclusive: p.exclusive,
      isActionOnly: o,
      isParent: d
    }), y = Bt({
      anchor: e,
      isActive: i,
      isDisabled: c,
      isGroupChild: u,
      isToggleable: w,
      size: O
    }), C = {};
    if (s && (C["data-bi-id"] = Vt(s, p, S)), p.href && !d) {
      const E = Xe(p.href);
      return _.ifFeature(
        "encore",
        /* @__PURE__ */ a.jsx(
          Ye,
          {
            ...C,
            "aria-disabled": c || null,
            "aria-selected": x === "option" ? f : void 0,
            className: y,
            component: p.component,
            containerRef: this._ref,
            href: p.href,
            id: p.id,
            onClick: v,
            onMouseEnter: () => {
              c || b();
            },
            role: x,
            target: E ? "_blank" : null,
            children: this._renderWithoutCheckbox()
          }
        ),
        /* @__PURE__ */ a.jsx(
          "a",
          {
            ...C,
            "aria-disabled": c || null,
            "aria-selected": x === "option" ? f : void 0,
            className: y,
            href: p.href,
            id: p.id,
            onClick: v,
            onMouseEnter: () => {
              c || b();
            },
            ref: this._ref,
            rel: E ? "noopener noreferrer" : null,
            role: x,
            target: E ? "_blank" : null,
            children: this._renderWithoutCheckbox()
          }
        )
      );
    }
    return /* @__PURE__ */ a.jsx(
      rt,
      {
        ...C,
        "aria-disabled": c || null,
        "aria-expanded": (d || null) && h,
        "aria-haspopup": d || null,
        "aria-selected": x === "option" ? f : void 0,
        className: y,
        component: _.ifFeature("encore", p.component),
        id: p.id,
        onClick: v,
        onMouseEnter: () => {
          c || b();
        },
        ref: this._ref,
        role: x,
        tabIndex: -1,
        children: w ? this._renderWithCheckbox() : this._renderWithoutCheckbox()
      }
    );
  }
}
const zt = st(Ut, $t), ke = Ge({ hasScrollbar: !1, ref: j() });
function Gt(t) {
  const [n, e] = qe(!1);
  return ve(() => {
    const s = t.current;
    if (!s)
      return;
    const r = Ze.hasVerticalScrollbar(s);
    (r || r !== n) && e(r);
  }), n;
}
function He({ children: t }) {
  const n = ne(null), e = Gt(n);
  return /* @__PURE__ */ a.jsx(ke.Provider, { value: { hasScrollbar: e, ref: n }, children: /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__scrollContainer", ref: n, children: t }) });
}
function qt(t) {
  return F("fab-MenuList__group", {
    "fab-MenuList__group--anchoredBottom": t.anchor === "bottom",
    "fab-MenuList__group--anchoredTop": t.anchor === "top"
  });
}
function Jt({ condition: t } = {}) {
  return F("fab-MenuList__nested", {
    [`fab-MenuList__nested${Se(t)}`]: !!t
  });
}
function me(t, n = {}) {
  return J(t) || !!n.isActionOnly;
}
function _e(t, n = {}) {
  return T(t) || !!n.isDisabled;
}
function Qt({
  active: t = !1,
  anchorRef: n,
  scrollContainerRef: e
}, s) {
  const r = ne();
  r.current = s, ve(() => {
    const o = e.current, i = n.current;
    if (!t || !i || !o)
      return;
    const c = new IntersectionObserver(
      ([h]) => {
        const u = r.current;
        !h.isIntersecting && u && u();
      },
      { root: o, threshold: 1 }
    );
    return c.observe(i), () => c.disconnect();
  }, [t, n, e]);
}
const Zt = {
  align: "start",
  side: "right"
};
function Xt({
  active: t = !1,
  children: n,
  condition: e,
  expanded: s = !1,
  item: r,
  menuId: o,
  placement: i = Zt,
  onMouseEnter: c,
  onCollapse: h,
  renderOption: u
}) {
  const { hasScrollbar: d, ref: f } = Je(ke), p = ne(null);
  return Qt(
    {
      active: t,
      anchorRef: p,
      scrollContainerRef: f
    },
    h
  ), /* @__PURE__ */ a.jsx(
    xe,
    {
      isInline: !1,
      isVisible: t && s,
      offset: { left: d ? 20 : 4 },
      parentId: o,
      placement: i,
      renderAnchor: () => /* @__PURE__ */ a.jsx("div", { onMouseEnter: c, ref: p, children: u(r, { isExpanded: t }) }, "parentAnchor"),
      renderVessel: () => /* @__PURE__ */ a.jsx("div", { className: Jt({ condition: e }), "data-menu-id": o, children: /* @__PURE__ */ a.jsx(He, { children: n }) }, "parentVessel")
    }
  );
}
class Ve extends Ie {
  constructor(e) {
    super(e);
    g(this, "_handleParentItemMouseEnter", (e) => {
      clearTimeout(this._parentTimer), this._parentTimer = setTimeout(() => {
        this.setState({ expandedParent: e });
      }, 200);
    });
    g(this, "_renderOption", (e, s = {}) => {
      const { biId: r, canSelectMultiple: o, role: i, onActiveItemChange: c, onSelect: h, renderOptionContent: u, selectedItems: d, size: f } = this.props, p = I(e);
      return /* @__PURE__ */ a.jsxs(A.Fragment, { children: [
        _.ifFeature("encore", e.anchor === "bottom" && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__anchorDividerBottom" })),
        /* @__PURE__ */ a.jsx(
          zt,
          {
            anchor: s.anchor ?? _.ifFeature("encore", e.anchor),
            biId: r,
            canSelectMultiple: o,
            isActionOnly: me(e, s),
            isActive: this._isActive(e),
            isDisabled: _e(e, s),
            isExpanded: s.isExpanded,
            isGroupChild: !!s.isGroupChild,
            isParent: p,
            isSelected: ae(e, d),
            item: e,
            onHover: () => c(e),
            onSelect: () => h(e),
            parentItem: s.parentItem,
            renderContent: u,
            role: i === "menu" ? "menuitem" : "option",
            size: f
          },
          this._getKey(e)
        ),
        _.ifFeature("encore", e.anchor === "top" && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__anchorDividerTop" }))
      ] }, this._getKey(e));
    });
    g(this, "state", {});
    this.menuRef = A.createRef();
  }
  _getKey(e) {
    return e.key ?? e.value;
  }
  _isActive(e) {
    const { activeItem: s } = this.props;
    return !!s && (z(s)(e) || I(e) && Y(e.items, s));
  }
  _isExpanded(e) {
    const { activeItem: s, isVisible: r } = this.props, { expandedParent: o } = this.state;
    return r && (o && z(o)(e) || Y(e.items, s));
  }
  _renderAddOption(e) {
    const { biId: s, onActiveItemChange: r, onSelect: o } = this.props;
    return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
      _.ifFeature("encore", e.anchor === "bottom" && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__anchorDividerBottom" })),
      /* @__PURE__ */ a.jsx(
        Ht,
        {
          anchor: e.anchor,
          biId: s,
          isActive: this._isActive(e),
          onHover: () => r(e),
          onSelect: () => o(e),
          children: e.text
        },
        this._getKey(e)
      ),
      _.ifFeature("encore", e.anchor === "top" && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__anchorDividerTop" }))
    ] });
  }
  _renderGroup(e, s = {}) {
    return s = {
      anchor: e.anchor,
      isActionOnly: me(e, s),
      isDisabled: _e(e, s),
      isGroupChild: !0
    }, /* @__PURE__ */ a.jsxs("div", { className: qt(e), children: [
      _.ifFeature("encore", /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__groupDivider" })),
      e.text && /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__groupText", children: e.text }),
      /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__groupChildren", children: I(e) && this._renderItems(e.items, s) }),
      e.anchor === "top" && _.ifFeature("encore", /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__anchorDivider" }))
    ] }, this._getKey(e));
  }
  _renderItems(e, s = {}) {
    return e.map((r) => r.type === "add" ? this._renderAddOption(r) : r.type === "group" ? this._renderGroup(r, s) : I(r) ? this._renderParentOption(r, s) : this._renderOption(r, s));
  }
  _renderParentOption(e, s) {
    const r = [...s.ancestors || [], e], o = this._isActive(e), i = this._isExpanded(e);
    return /* @__PURE__ */ a.jsx(
      Xt,
      {
        active: o,
        expanded: i,
        item: e,
        onCollapse: () => this.setState({ expandedParent: null }),
        onMouseEnter: () => this._handleParentItemMouseEnter(e),
        renderOption: this._renderOption,
        children: this._renderItems(e.items, { ...s, ancestors: r, parentItem: e })
      },
      this._getKey(e)
    );
  }
  _getItemIds(e) {
    return e.reduce((s, r) => {
      let o = `${s} ${r.id}`;
      return r.items && this._isExpanded(r) && (o += this._getItemIds(r.items)), o;
    }, "");
  }
  componentDidMount() {
    window.setTimeout(() => {
      var e;
      (e = this.menuRef.current) == null || e.focus();
    }, 50);
  }
  componentDidUpdate(e) {
    const { isVisible: s } = this.props;
    s && s !== e.isVisible && this.menuRef.current && window.setTimeout(() => {
      var r;
      (r = this.menuRef.current) == null || r.focus();
    }, 50);
  }
  render() {
    const { activeItem: e, canSelectMultiple: s, items: r, menuId: o, role: i, placeholder: c } = this.props, h = r.filter((b) => b.anchor === "bottom"), u = r.filter((b) => b.anchor === "top"), d = r.filter((b) => b.anchor !== "top" && b.anchor !== "bottom"), f = this._getItemIds(r), p = {
      "aria-activedescendant": e ? e.id : null,
      "aria-multiselectable": i === "listbox" ? s : void 0,
      "aria-owns": f,
      id: o,
      ref: this.menuRef,
      role: i,
      tabIndex: -1
    };
    return /* @__PURE__ */ a.jsxs("div", { ...p, className: "fab-MenuList", children: [
      u.length > 0 && this._renderItems(u),
      d.length > 0 ? /* @__PURE__ */ a.jsx(He, { children: this._renderItems(d) }) : null,
      d.length < 1 && c ? /* @__PURE__ */ a.jsx("div", { className: "fab-MenuList__placeholder", children: c }) : null,
      h.length > 0 && this._renderItems(h)
    ] });
  }
}
g(Ve, "defaultProps", {
  isVisible: !1,
  menuPlacement: {
    align: "start",
    side: "bottom"
  },
  onItemHover: l.noop,
  role: "menu"
});
const Yt = window.jQuery ? $.__("Search...") : "Search...";
class en extends G {
  constructor() {
    super(...arguments);
    g(this, "_handleChange", (e) => {
      const { onSearch: s } = this.props, r = e.target.value;
      s(r);
    });
    g(this, "_ref", j());
  }
  focus() {
    Pe(this._ref.current);
  }
  render() {
    const { activeItem: e, searchPlaceholder: s, searchText: r } = this.props;
    return (
      /* Labels do not need "for" attributes if they wrap the related inputs. */
      /* eslint-disable jsx-a11y/label-has-for */
      /* @__PURE__ */ a.jsxs("label", { className: "fab-MenuSearch", children: [
        /* @__PURE__ */ a.jsx("div", { className: "fab-MenuSearch__icon", children: _.ifFeature("encore", /* @__PURE__ */ a.jsx(P, { name: "magnifying-glass-regular", size: 16 }), /* @__PURE__ */ a.jsx(Ce, { "aria-hidden": !0 })) }),
        /* @__PURE__ */ a.jsx(
          "input",
          {
            "aria-activedescendant": (e == null ? void 0 : e.id) || null,
            "aria-label": window.jQuery ? $.__("Search") : "Search",
            className: "fab-MenuSearch__input",
            onChange: this._handleChange,
            placeholder: s ?? Yt,
            ref: this._ref,
            type: "text",
            value: r
          }
        )
      ] }, "menuVesselSearch")
    );
  }
}
function tn(t) {
  const {
    activeItem: n,
    biId: e,
    canSelectMultiple: s = !1,
    children: r,
    condition: o,
    isAttached: i = !1,
    items: c = [],
    isOpen: h,
    listRole: u,
    menuId: d,
    menuPlacement: f,
    onActiveItemChange: p,
    onAdd: b,
    onBlur: v,
    onSearch: S,
    onSelect: O,
    renderOptionContent: x,
    searchRef: w,
    searchPlaceholder: y,
    searchText: C,
    selectedItems: E,
    shouldShowSearch: V,
    size: B,
    width: Z,
    ...W
  } = t, K = /^16/.test(A.version) ? { onClickCapture: (M) => M.nativeEvent.stopImmediatePropagation() } : {};
  return (
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    /* @__PURE__ */ a.jsxs(
      "div",
      {
        className: Tt({ isAttached: i, condition: o, menuPlacement: f, width: Z }),
        "data-menu-id": d,
        "data-fabric-component": W["data-fabric-component"],
        onBlur: v,
        onClick: (M) => M.stopPropagation(),
        ...K,
        children: [
          /* @__PURE__ */ a.jsx("div", { className: "fab-MenuVessel__outerFacade", children: /* @__PURE__ */ a.jsx("div", { className: Rt({ condition: o }) }, "innerFacade") }, "outerFacade"),
          /* @__PURE__ */ a.jsxs("div", { className: "fab-MenuVessel__list", children: [
            r,
            V ? /* @__PURE__ */ a.jsx("div", { className: "fab-MenuVessel__search", children: /* @__PURE__ */ a.jsx(
              en,
              {
                activeItem: n,
                onSearch: S,
                ref: w,
                searchPlaceholder: y,
                searchText: C
              }
            ) }) : null,
            /* @__PURE__ */ a.jsx(
              Ve,
              {
                activeItem: n,
                biId: e,
                canSelectMultiple: s,
                condition: o,
                isVisible: h,
                items: c,
                menuId: d,
                menuPlacement: f,
                onActiveItemChange: p,
                onAdd: b,
                onSelect: O,
                placeholder: V ? Nt : "",
                renderOptionContent: x,
                role: u,
                selectedItems: E,
                size: B
              }
            )
          ] })
        ]
      }
    )
  );
}
const nn = {
  isActionOnly: !0,
  items: [
    {
      value: "fab-menu-add-option",
      type: "add"
    }
  ],
  key: "fab-menu-add-group",
  type: "group"
}, sn = 8, ge = $e.createLogger("@fabric/menu | <Menu />"), ce = class ce extends G {
  constructor() {
    super(...arguments), this._handleActiveItemChange = (n) => {
      this._activateItem(n);
    }, this._handleAdd = async () => {
      const { canSelectMultiple: n, onAdd: e } = this.props;
      return this.setState({
        isAdding: !0
      }), e == null ? void 0 : e().then(
        () => {
          this.setState({
            isAdding: !1
          }), n || this._focusAndClose();
        },
        () => {
          this.setState({
            isAdding: !1
          });
        }
      );
    }, this._handleBlur = (n) => {
      const { onBlur: e } = this.props;
      typeof e == "function" && !fe(this._id)(n.relatedTarget) && e();
    }, this._handleClose = () => {
      this._close();
    }, this._handleSearch = (n) => {
      const { onSearch: e } = this.props;
      typeof e == "function" ? e(n) : this.setState({ searchText: n });
    }, this._handleOpen = () => {
      const { isDisabled: n, isOpen: e, onOpen: s } = this.props;
      !e && !n && s && s();
    }, this._handleSelect = (n, e = !1) => {
      const { canSelectMultiple: s, onDeselect: r = l.noop, onSelect: o = l.noop } = this.props, { items: i, selectedItems: c } = this.state, h = re(i, n);
      if (!n || T(n, i) || I(n)) {
        n && !T(n, i) && this._activateItem(q(n.items));
        return;
      }
      if (n.type === "add")
        return this._handleAdd();
      let u;
      (!e || e && !s) && (ae(n, c) && s ? u = r(n, h, { isQuickSelect: e }) : u = o(n, h, { isQuickSelect: e })), this._activateItem(n), Promise.resolve(u).then(
        () => {
          const d = !e && (!s || J(n, i) || n.exclusive);
          this._isMounted && d && this._focusAndClose();
        },
        () => ge.warn("An error occured when selecting an item. Not attempting to close Menu")
      );
    }, this._id = l.uniqueId("fab-menu"), this._anchorRef = j(), this._searchRef = j(), this.state = {
      activeItem: null,
      searchText: ""
    };
  }
  get _activeItem() {
    const { activeItem: n = null, items: e, selectedItems: s } = this.state, { onSearch: r } = this.props;
    return ot({
      activeItem: n,
      items: e,
      selectedItems: s,
      searchText: typeof r == "function" ? "" : this._searchText
    });
  }
  get _searchText() {
    const { searchText: n } = this.props, { searchText: e } = this.state;
    return typeof n < "u" ? n : e;
  }
  static getDerivedStateFromProps(n) {
    const { canSelectMultiple: e, items: s = [], onAdd: r, selectedItems: o } = n, i = l.isFunction(r) && !lt(s) ? [...s, nn] : s;
    let c = Oe(i, o);
    return c.length > 1 && !e && (c = c.slice(-1), ge.error("Multiple items were selected but menu is not configured for multi-item selection.")), {
      items: i,
      selectedItems: c
    };
  }
  _activateItem(n) {
    I(n) && this._focusSearch(), this.setState({
      activeItem: n
    });
  }
  _close() {
    const { onClose: n } = this.props;
    this.setState({
      activeItem: null,
      searchText: ""
    }), n && n();
  }
  _addIds(n) {
    return n.forEach((e) => {
      e.id || (e.id = l.uniqueId("menu-item-")), e.items && this._addIds(e.items);
    }), n;
  }
  _getListItems() {
    const { items: n = [] } = this.state, { onSearch: e } = this.props, s = this._addIds(n);
    return typeof e == "function" ? n : H(s || [], this._searchText);
  }
  _focusAnchor() {
    this._anchorRef.current && this._anchorRef.current.focus();
  }
  _focusAndClose() {
    this._focusAnchor(), this._close();
  }
  _focusSearch() {
    const { isOpen: n } = this.props, e = this._searchRef.current;
    e && n && setTimeout(() => {
      e.focus();
    }, 100);
  }
  focus() {
    this._focusAnchor();
  }
  componentDidMount() {
    this._isMounted = !0, this._focusSearch();
  }
  componentDidUpdate(n) {
    const { isOpen: e } = this.props;
    e !== n.isOpen && this._focusSearch();
  }
  componentWillUnmount() {
    this._isMounted = !1;
  }
  render() {
    const {
      ariaLabel: n,
      biId: e,
      canQuickSelect: s,
      canSelectMultiple: r,
      condition: o,
      children: i,
      inline: c = !0,
      isAttached: h,
      isDisabled: u,
      isFullWidth: d,
      isOpen: f,
      listRole: p,
      onAdd: b,
      placement: v,
      renderOptionContent: S,
      renderToggle: O,
      searchPlaceholder: x,
      searchThreshold: w,
      showSearch: y,
      size: C,
      width: E,
      ...V
    } = this.props, { isAdding: B, items: Z, selectedItems: W } = this.state, K = !u && f, M = this._getListItems(), le = it(y, w, Z), Be = [V["data-fabric-component"], "Menu"].filter(Boolean).join(" ");
    return /* @__PURE__ */ a.jsx(Te, { isDescendant: fe(this._id), isEnabled: K && !B, onClickOut: this._handleClose, children: /* @__PURE__ */ a.jsx(
      xe,
      {
        "data-fabric-component": Be,
        id: this._id,
        isAttached: h,
        isFullWidth: d,
        isInline: c,
        isVisible: K,
        placement: v,
        renderAnchor: ({ appliedPlacement: X }) => /* @__PURE__ */ a.jsx(
          Ne,
          {
            activeItem: this._activeItem,
            ariaLabel: n,
            biId: e,
            canQuickSelect: s,
            canSelectMultiple: r,
            isAdding: B,
            isDisabled: u,
            isFullWidth: d,
            isOpen: f,
            items: M,
            menuId: this._id,
            menuPlacement: X,
            onActiveItemChange: this._handleActiveItemChange,
            onBlur: this._handleBlur,
            onClose: this._handleClose,
            onOpen: this._handleOpen,
            onSelect: this._handleSelect,
            ref: this._anchorRef,
            renderToggle: O,
            selectedItems: W,
            shouldShowSearch: le
          }
        ),
        renderVessel: ({ appliedPlacement: X }) => /* @__PURE__ */ a.jsx(
          tn,
          {
            activeItem: this._activeItem,
            biId: e,
            canSelectMultiple: r,
            condition: o,
            isAttached: h,
            isOpen: f,
            items: M,
            listRole: p,
            menuId: this._id,
            menuPlacement: X,
            onActiveItemChange: this._handleActiveItemChange,
            onAdd: b,
            onBlur: this._handleBlur,
            onSearch: this._handleSearch,
            onSelect: this._handleSelect,
            renderOptionContent: S,
            searchPlaceholder: x,
            searchRef: this._searchRef,
            searchText: this._searchText,
            selectedItems: W,
            shouldShowSearch: le,
            size: C,
            width: E,
            children: i
          }
        )
      }
    ) });
  }
};
ce.defaultProps = {
  canQuickSelect: !1,
  canSelectMultiple: !1,
  isFullWidth: !1,
  isOpen: !1,
  items: [],
  onDeselect: l.noop,
  onClose: l.noop,
  onSelect: l.noop,
  onOpen: l.noop,
  renderOptionContent: l.noop,
  showSearch: "auto",
  searchThreshold: sn
};
let be = ce;
export {
  be as M,
  U as a,
  On as b,
  ye as c,
  Ee as d,
  re as e,
  k as f,
  q as g,
  Oe as h,
  yn as i,
  En as j,
  lt as k,
  I as l,
  wn as m,
  Y as n,
  J as o,
  ie as p,
  T as q,
  Q as r,
  z as s,
  ae as t,
  H as u,
  je as v,
  Se as w
};
//# sourceMappingURL=menu-63UgiRJf.mjs.map
